import { Box, Grid, Skeleton, Stack } from '@packages/shared';

export const MiniDVSkeleton = () => (
  <Grid container sx={{ overflowY: 'auto' }}>
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        position: 'relative',
        p: 2.5,
        '::after': {
          content: '""',
          position: 'absolute',
          zIndex: 10,
          width: ['auto', 'auto', '1px'],
          height: ['1px', '1px', 'auto'],
          top: ['auto', 'auto', 20],
          bottom: [0, 0, 20],
          right: 0,
          left: [0, 0, 'auto'],
          bgcolor: 'grey.main',
        },
      }}
    >
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: ['row', 'row', 'column'],
            gap: 3,
            mb: 3,
          }}
        >
          <Box sx={{ flex: ['0 0 33%', '0 0 33%', 'auto'], width: '100%' }}>
            <Skeleton
              variant="rectangular"
              sx={{ position: 'relative', width: '100%', height: 0, pt: '100%' }}
            />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: [0.875, 0.875, 1],
              width: '100%',
            }}
          >
            <Skeleton variant="rectangular" sx={{ height: [20, 20, 30] }} />
            <Skeleton variant="rectangular" sx={{ height: [20, 20, 30], width: [150, 200, 250] }} />
            <Skeleton variant="rectangular" sx={{ height: [20, 20, 30], width: [100, 100, 150] }} />
            <Skeleton variant="rectangular" sx={{ height: [20, 20, 30], width: [100, 100, 150] }} />
            <Stack
              gap={2}
              direction="row"
              sx={{ span: { width: [30, 40, 50], height: [25, 35, 40] } }}
            >
              <Skeleton variant="rectangular" />
              <Skeleton variant="rectangular" />
              <Skeleton variant="rectangular" />
              <Skeleton variant="rectangular" />
            </Stack>
          </Box>
        </Box>
        <Skeleton variant="rectangular" height={30} />
      </>
    </Grid>
    <Grid item xs={12} md={6} sx={{ p: 2.5 }}>
      <Stack direction="column" gap={2}>
        <Skeleton variant="rectangular" height={80} />
        <Skeleton variant="rectangular" height={80} />
        <Skeleton variant="rectangular" height={80} />
        <Skeleton variant="rectangular" height={80} />
        <Skeleton variant="rectangular" height={80} />
      </Stack>
    </Grid>
  </Grid>
);
